import { Circle, styled } from 'tamagui';

export const Indicator = styled(Circle, {
  position: 'absolute',
  backgroundColor: '$brand',
  top: -2,
  right: -2,
  zIndex: 2,
});
